import { createBrowserRouter, Navigate } from 'react-router-dom';
import LoginPage from '@/pages/auth/LoginPage';
import RegisterPage from '@/pages/auth/RegisterPage';
import SSOCallback from '@/pages/auth/SSOCallback';
import DashboardPage from '@/pages/dashboard/DashboardPage';
import DeviceSchedulesPage from '@/pages/devices/DeviceSchedulesPage';
import DeviceMapPage from '@/pages/devices/DeviceMapPage';
import DeviceChartsPage from '@/pages/devices/DeviceChartsPage';
import DeviceManagementPage from '@/pages/devices/DeviceManagementPage';
import AccountPage from '@/pages/account/AccountPage';
import SecurityPage from '@/pages/security/SecurityPage';
import ErrorPage from '@/pages/ErrorPage';
import AuthLayout from '@/components/layouts/AuthLayout';
import JoinOrganizationPage from '@/pages/auth/JoinOrganizationPage';
import HelpPage from './pages/HelpPage';
import EventsPage from './pages/EventsPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />,
    errorElement: <ErrorPage />
  },
  {
    path: '/login',
    element: <LoginPage />,
    errorElement: <ErrorPage />
  },
  {
    path: '/register',
    element: <RegisterPage />,
    errorElement: <ErrorPage />
  },
  {
    path: '/auth/callback',
    element: <SSOCallback />,
    errorElement: <ErrorPage />
  },
  {
    path: '/join/:token',
    element: <JoinOrganizationPage />
  },
  // Protected routes
  {
    element: <AuthLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/dashboard',
        element: <DashboardPage />
      },
      {
        path: '/devices/schedules',
        element: <DeviceSchedulesPage />
      },
      {
        path: '/devices/map',
        element: <DeviceMapPage />
      },
      {
        path: '/devices/charts',
        element: <DeviceChartsPage />
      },
      {
        path: '/devices/management',
        element: <DeviceManagementPage />
      },
      {
        path: '/events',
        element: <EventsPage />
      },
      {
        path: '/account',
        element: <AccountPage />
      },
      {
        path: '/security',
        element: <SecurityPage />
      }
    ]
  },
  {
    path: '/help',
    element: <HelpPage />,
  },
  // Catch-all route for 404
  {
    path: '*',
    element: <ErrorPage />
  }
]); 